import config from "../config.json"
import Cookies from "js-cookie";

//permet de mettre une couleur dans le config.json en global sur un element
export const setEnvironmentColors = (setColorFunctions) => {
  const environnement = Cookies.get("Env");
  if (config[environnement]) {
    const colors = config[environnement];
    setColorFunctions.forEach(([setColor, colorKey]) => {
      if (colors[colorKey]) {
        setColor(colors[colorKey]);
      }
    });
  } else {
    console.warn("Environnement non configuré dans config.json");
  }
};
